import React, { createContext, RefObject, useContext } from "react";

export const LabelBoundingContainerContext =
  createContext<RefObject<HTMLDivElement | null> | null>(null);

export const useLabelBoundingContainerRef = () =>
  useContext(LabelBoundingContainerContext);

type LabelBoundingContainerProviderProps = {
  containerRef: RefObject<HTMLDivElement | null>;
  children: React.ReactNode;
};

export function LabelBoundingContainerProvider({
  containerRef,
  children,
}: LabelBoundingContainerProviderProps) {
  return (
    <LabelBoundingContainerContext.Provider value={containerRef}>
      {children}
    </LabelBoundingContainerContext.Provider>
  );
}
